import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=70b631e9&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=js&"
export * from "./BaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=70b631e9&lang=scss&"
import style1 from "./BaseDialog.vue?vue&type=style&index=1&id=70b631e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b631e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b631e9')) {
      api.createRecord('70b631e9', component.options)
    } else {
      api.reload('70b631e9', component.options)
    }
    module.hot.accept("./BaseDialog.vue?vue&type=template&id=70b631e9&scoped=true&", function () {
      api.rerender('70b631e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/BaseDialog/BaseDialog.vue"
export default component.exports